import { render, staticRenderFns } from "./CourseBtn.vue?vue&type=template&id=b70470c2&"
import script from "./CourseBtn.vue?vue&type=script&lang=ts&"
export * from "./CourseBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports